import { render, staticRenderFns } from "./limited.vue?vue&type=template&id=71f60ef3&scoped=true&"
import script from "./limited.vue?vue&type=script&lang=ts&"
export * from "./limited.vue?vue&type=script&lang=ts&"
import style0 from "./limited.vue?vue&type=style&index=0&id=71f60ef3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f60ef3",
  null
  
)

export default component.exports